/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entrytitle1Inputs */

const en_entrytitle1 = /** @type {(inputs: Entrytitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entry`)
};

const de_entrytitle1 = /** @type {(inputs: Entrytitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eintritt`)
};

/**
* | output |
* | --- |
* | "Entry" |
*
* @param {Entrytitle1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entrytitle1 = /** @type {((inputs?: Entrytitle1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entrytitle1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entrytitle1(inputs)
	return de_entrytitle1(inputs)
});
export { entrytitle1 as "entryTitle" }